
import React, { Component } from 'react';
import { Link } from 'react-router';
import { Row } from 'reactstrap';
import { checkString, checkIntNumber } from '../../../../formValidator';
import { FieldCol, FieldGroup, FieldLabel, FieldTextarea, FieldSelect, FieldInput, FieldDate } from '../../../contracts/Elements';
export default class AddEditGalley extends Component{
  constructor(props){
    super(props);
    this.state = {
      galley: {},
      error: {}
    }
  }
  componentDidMount(){
    let data = JSON.parse(JSON.stringify(this.props.galleyObj));
    if(this.props.type == 'edit' || this.props.type == 'view'){
      let id = data.aircraft.id;
      data = {
        ...data,
        aircraft: id,
        location: this.props.galleyObj.location.value,
        locationName: this.props.galleyObj.location.label,
        galley_type: this.props.galleyObj.galley_type.value,
        galleyTypeName: this.props.galleyObj.galley_type.label,
        configuration: this.props.galleyObj.configuration && this.props.galleyObj.configuration.value ? this.props.galleyObj.configuration.value : null,
        configuration_name: this.props.galleyObj.configuration && this.props.galleyObj.configuration.label ? this.props.galleyObj.configuration.label : null,
      }
    }
    this.setState({
      galley:data
    });
  }
  updateForm = (type, value) => {
    this.setState(prevState => ({
      ...prevState,
      galley: {
        ...prevState.galley,
        [type]: value
      },
      error: {
        ...prevState.error,
        [type]:''
      }
    }))
  }
  addEditGalley = (e) => {
    e.preventDefault();
    const validateNewInput = {
      name: checkString({value: this.state.galley.name, required: true, minLength: '', maxLength: '', message: 'Please enter Name'}),
    };
    if (Object.keys(validateNewInput).every((k) => { return validateNewInput[k] === '' })) {
      this.props.addEditTechSummary(this.state.galley, this.props.type, 'galleyList', 'galleyCrud');
    }else{
      this.setState({
        error: validateNewInput
      });
    }

  }
  render(){
    const { galley, error } = this.state;
    const { type, techConstants} = this.props;
    if(!Object.keys(galley).length){
      return null
    }
    return(
      <form onSubmit={(e) => this.addEditGalley(e)}>
        <div style={{ height: (window.innerHeight - 157) + 'px', overflow:'auto',marginBottom:'60px' }}>
          <Row>
            <FieldCol md="12">
              <FieldGroup className="form-group">
                <FieldLabel className="label">
                  Name
                  { type != 'view' ? <sup className="reqStar"> * </sup>:null}
                </FieldLabel>
                <FieldInput
                  value={galley.name}
                  type={type}
                  keyParam="name"
                  updateField={this.updateForm}
                />
              <h6 className="error-msg">{error.name}</h6>
              </FieldGroup>
            </FieldCol>
            <FieldCol md="12">
              <FieldGroup className="form-group">
                <FieldLabel className="label">Part Number</FieldLabel>
                <FieldInput
                  value={galley.part_number}
                  type={type}
                  keyParam="part_number"
                  updateField={this.updateForm}
                />
              </FieldGroup>
            </FieldCol>
            <FieldCol md="12">
              <FieldGroup className="form-group">
                <FieldLabel className="label">
                  Quantity
                </FieldLabel>
                <FieldInput
                  value={galley.quantity}
                  type={type}
                  keyParam="quantity"
                  updateField={this.updateForm}
                />
              <h6 className="error-msg">{error.quantity}</h6>
              </FieldGroup>
            </FieldCol>
            <FieldCol md="12">
              <FieldGroup className="form-group">
                <FieldLabel className="label">
                  Configuration
                </FieldLabel>
                <FieldSelect
                  placeholder='Select Configuration'
                  keyParam="configuration"
                  value={galley.configuration}
                  type={type}
                  options={techConstants.filter(item => item.type=="galley_configuration")}
                  updateField={this.updateForm}
                  labelKey= 'label'
                  valueKey='value'
                  name={galley.configuration_name}
                />
                <h6 className="error-msg">{error.configuration}</h6>
              </FieldGroup>
            </FieldCol>

            <FieldCol md="12">
              <FieldGroup className="form-group">
                <FieldLabel className="label">
                  Type
                </FieldLabel>
                <FieldSelect
                  placeholder='Select Type'
                  keyParam="galley_type"
                  value={galley.galley_type}
                  type={type}
                  options={techConstants.filter(item => item.type=="galley_type")}
                  updateField={this.updateForm}
                  labelKey= 'label'
                  valueKey='value'
                  name={galley.galleyTypeName}
                />
                <h6 className="error-msg">{error.galley_type}</h6>
              </FieldGroup>
            </FieldCol>
            <FieldCol md="12">
              <FieldGroup className="form-group">
                <FieldLabel className="label">
                  Location
                </FieldLabel>
                <FieldSelect
                  placeholder='Select Location'
                  keyParam="location"
                  value={galley.location}
                  type={type}
                  options={techConstants.filter(item => item.type=="interior_location")}
                  updateField={this.updateForm}
                  labelKey= 'label'
                  valueKey='value'
                  name={galley.locationName}
                />
                <h6 className="error-msg">{error.location}</h6>
              </FieldGroup>
            </FieldCol>
            <FieldCol md="12">
              <FieldGroup className="form-group">
                <FieldLabel className="label">Manufacturer</FieldLabel>
                <FieldInput
                  value={galley.manufacturer}
                  type={type}
                  keyParam="manufacturer"
                  updateField={this.updateForm}
                />
              </FieldGroup>
            </FieldCol>
            <FieldCol md="12">
              <FieldGroup className="form-group">
                <FieldLabel className="label">Remarks</FieldLabel>
                <FieldTextarea
                  value={galley.remarks}
                  type={type}
                  keyParam="remarks"
                  updateField={this.updateForm}
                />
              </FieldGroup>
            </FieldCol>
          </Row>
        </div>
        { type !== 'view' ?
        <div className="submit-block">
          <input type="submit" className="primary-btn" value="Save Changes"/>
          <Link onClick={() => this.props.toggleEditSideBar()} >Cancel</Link>
        </div> : null }
      </form>
    )
  }
}
